import { BaseApiService } from './BaseApiService';
import { sharedTokenRefresh } from './tokenRefresh';

export class FeatureUsageApiService extends BaseApiService {
    constructor() {
        super(sharedTokenRefresh);
    }

    /** Best-effort: fire-and-forget, ignore failures. */
    track(featureName: string): void {
        this.postJson('/v1/feature-usage/track', { featureName })
            .then(res => this.handleResponse<{ success: boolean }>(res))
            .catch(() => {/* intentionally swallowed */});
    }
}

export const featureUsageApiService = new FeatureUsageApiService();
